import React, { forwardRef } from "react";
import Select from "react-select";

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: "hsl(var(--input))",
        borderColor: state.isFocused ? "hsl(var(--ring))" : "hsl(var(--border))",
        color: "hsl(var(--foreground))",
        boxShadow: state.isFocused ? "0 0 0 2px hsl(var(--ring))" : provided.boxShadow,
        "&:hover": { borderColor: "hsl(var(--border))" },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: "hsl(var(--popover))",
        border: "1px solid hsl(var(--border))",
        borderRadius: "0.5rem",
        boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? "hsl(var(--primary))"
            : state.isFocused
                ? "hsl(var(--accent))"
                : "hsl(var(--popover))",
        color: state.isSelected ? "hsl(var(--primary-foreground))" : "hsl(var(--foreground))",
        cursor: "pointer",
        "&:active": { backgroundColor: "hsl(var(--accent))" },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "hsl(var(--foreground))",
    }),
    input: (provided) => ({
        ...provided,
        color: "hsl(var(--foreground))",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "hsl(var(--muted-foreground))",
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: "hsl(var(--border))",
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: state.isFocused ? "hsl(var(--foreground))" : "hsl(var(--muted-foreground))",
    }),
};

const ThemedSelect = forwardRef(({ styles, ...props }, ref) => (
    <Select
        ref={ref}
        styles={{ ...customStyles, ...styles }}
        {...props}
    />
));

ThemedSelect.displayName = "ThemedSelect";

export default ThemedSelect;
